import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#2b2b2b] text-white/60 font-serif">
      <div className="mx-auto max-w-[1200px] px-5 py-[70px]">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-[60px]">
          {/* Column 1: About Author Short */}
          <div>
            <h4 className="mb-6 text-2xl font-medium text-white/90">About the Author</h4>
            <p className="max-w-[320px] text-[16px] leading-[1.9] text-white/55">
              Sweta Singh crafts moving stories of love, resilience, and quiet heroism. Her writing blends warmth, depth, and a touch of intrigue inspired by everyday life.
            </p>
          </div>

          {/* Column 2: Contact Info */}
          <div>
            <h4 className="mb-6 text-2xl font-medium text-white/90">Contact</h4>
            <ul className="space-y-4 text-[16px]">
              <li>
                <a
                  href="mailto:singhsweta112@gmail.com"
                  className="flex items-center gap-2 text-white/55 hover:text-white/90 transition"
                >
                  <svg width={18} height={18} viewBox="0 0 24 24" fill="none" className="inline" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.25 6.75A2.25 2.25 0 0 1 4.5 4.5h15a2.25 2.25 0 0 1 2.25 2.25v10.5A2.25 2.25 0 0 1 19.5 19.5h-15A2.25 2.25 0 0 1 2.25 17.25V6.75z" stroke="currentColor" strokeWidth="1.5" />
                    <path d="m3 7.5 8.547 6.43a.75.75 0 0 0 .906 0L21 7.5" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                  singhsweta112@gmail.com
                </a>
              </li>
              <li>
                <span className="flex items-center gap-2 text-white/55">
                  <FaMapMarkerAlt size={16} className="inline" />
                  Delhi, India
                </span>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h4 className="mb-6 text-2xl font-medium text-white/90">Quick Links</h4>
            <ul className="space-y-3 text-[16px]">
              <li>
                <a
                  href="/"
                  className="text-white/55 transition hover:text-white/90"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-white/55 transition hover:text-white/90"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-white/55 transition hover:text-white/90"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Social Media */}
          <div>
            <h4 className="mb-6 text-2xl font-medium text-white/90">Social media</h4>
            {/* Social Icons */}
            <div className="mt-6 flex items-center gap-5">
              <SocialIcon
                label="Instagram"
                href="https://www.instagram.com/authorsweta2025"
              >
                <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-5 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.2-.9a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </SocialIcon>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom strip */}
      <div className="bg-black py-7 text-center">
        {/* <p className="text-[12px] uppercase tracking-[0.3em] text-white/60">
          © 2026, ALL RIGHTS RESERVED
        </p> */}
        <p className="text-md mt-1 tracking-wide text-white/40">
          Tech Partner:{" "}
          <a
            href="https://www.gowappily.in"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-white/70 transition"
          >
            Gowappily Infotech
          </a>
        </p>
      </div>
    </footer>
  );
};

const SocialIcon = ({ children, label, href }) => {
  return (
    <a
      href={href || "#"}
      aria-label={label}
      className="group relative flex items-center gap-2 px-3 py-1  transition shadow-sm hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
      tabIndex={0}
      target={href?.startsWith("http") ? "_blank" : undefined}
      rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}
    >
      <span className="inline-flex items-center justify-center h-7 w-7 bg-[#262626] rounded-full">
        <svg
          viewBox="0 0 24 24"
          className="h-4 w-4 fill-white/90 group-hover:fill-white"
          xmlns="http://www.w3.org/2000/svg"
        >
          {children}
        </svg>
      </span>
      <span className="ml-2 text-white/85 text-sm font-medium tracking-wide group-hover:text-white line-clamp-1">
        {label}
      </span>
      <span className="ml-2 text-white/55 text-xs font-mono">
        {/* Show the handle name, e.g. @authorsweta2025 for Instagram */}
        {label === "Instagram" && "@authorsweta2025"}
        {label === "Facebook" && "@authorsweta"}
        {label === "Twitter" && "@authorsweta"}
        {label === "LinkedIn" && "Author Sweta Singh"}
      </span>
    </a>
  );
};

export default Footer;
